import { createContext } from "react";
const ExpandedRowContext = createContext({
    id: "",
    expanded: false,
    disabled: false,
    handleChange: () => {
        return;
    },
});
export default ExpandedRowContext;
//# sourceMappingURL=context.js.map